import React, { Component } from "react";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import IconButton from '@material-ui/core/IconButton';

class FullText extends Component {
	constructor(props) {
		super(props);
		this.state= {
			dialogOpen: false
		}
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}
	
	handleOpen(){
		this.setState({dialogOpen: true});
	};
	
	handleClose(){
		this.setState({dialogOpen: false});
	};
	
	handleClick(id){
//		console.log("handleClick("+id+")");
		var index = id.split("_");
		this.handleClose();
		this.props.action(index[0], index[1]);
	}

	render() {
		var TUs = [];
		var Segs;
		if( (typeof this.props.editor.TUs !=='undefined') && (this.props.editor.TUs!==null) ){
			for (var iTU = 0; iTU < this.props.editor.TUs.length; iTU++) {
				Segs = [];
				for (var iSeg = 0; iSeg < this.props.editor.TUs[iTU].segments.length; iSeg++) {
//					console.log(this.props.editor.TUs[iTU].segments[iSeg]["src"].text);
					var pretraduccio="";
					if( (typeof this.props.editor.TUs[iTU].segments[iSeg]["ECL TMX"] !=='undefined') && (this.props.editor.TUs[iTU].segments[iSeg]["ECL TMX"]!==null) ){
						if(this.props.editor.TUs[iTU].segments[iSeg]["ECL TMX"].matchQuality>95){
							pretraduccio="match100";
						}else{
							pretraduccio="match75";
						}
					}else if( (typeof(this.props.repetitions)!=="undefined" && this.props.repetitions !=null &&
							typeof(this.props.repetitions.target[iTU])!=="undefined" &&
							typeof(this.props.repetitions.target[iTU][iSeg]!="undefined") && 
							this.props.repetitions.target[iTU][iSeg]!=null) ||
							(this.props.repetitions !=null &&
							typeof(this.props.repetitions.source[iTU])!=="undefined" &&
							typeof(this.props.repetitions.source[iTU][iSeg]!="undefined") && 
							this.props.repetitions.source[iTU][iSeg]!=null)){
						pretraduccio="repetition";
					}
					Segs.push(<span id={iTU+"_"+iSeg} class={["segment", pretraduccio].join(' ')} onClick={e => { this.handleClick(e.target.id); }}>{this.props.editor.TUs[iTU].segments[iSeg]["src"].text}</span>);
				}
				TUs.push(<p>{Segs}</p>);
			}
		}
//		console.log(TUs);
		return (
		<span>
			<Dialog open={this.state.dialogOpen} onClose={this.handleClose} fullWidth={true} maxWidth = {'md'}>
				<DialogTitle>Document text</DialogTitle>
				<DialogContent dividers>
					<DialogContentText>
					{TUs}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleClose} color="primary">
					CLOSE
					</Button>
				</DialogActions>
			</Dialog>
			<Tooltip title="View full text"><Icon style={{cursor: "pointer"}} onClick={() => { this.handleOpen(); }}><IconButton color="inherit" aria-label="Full text"><DescriptionOutlinedIcon /></IconButton></Icon></Tooltip>
		</span>
		);
	}
}

export default FullText;